/* Phone: pinned product photo that eases down to ~80% while the options scroll under it (Angara-style).
   Markup: the pinned block carries data-pin-photo; its photo box carries data-pin-main. The block is
   position:sticky in CSS (inside its own layout column, so it releases once the buy area scrolls past);
   this script sets --ts2-pin-top (under the pinned site header) and --ts2-k (1 -> 0.8) on the block.
   Same behaviour as the pdp-v2 product page. */
(function(){
  var blocks = document.querySelectorAll('[data-pin-photo]');
  if (!blocks.length) return;
  var mq = window.matchMedia('(max-width: 989px)');
  var MIN = 0.8;
  function headerBottom(){
    var off = 0, hs = document.querySelectorAll('.tsx.is-pinned, .tsx-ann--scroll, .megaContainer, .shopify-section-header');
    for (var i = 0; i < hs.length; i++){
      var cs = getComputedStyle(hs[i]);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      if (cs.visibility === 'hidden') continue;
      var r = hs[i].getBoundingClientRect();
      if (r.top <= 1 && r.bottom > off) off = r.bottom;
    }
    return Math.max(0, Math.round(off));
  }
  function one(g){
    var main = g.querySelector('[data-pin-main]') || g;
    var scope = g.parentElement;
    var track = g.querySelector('[data-tsb-track],[data-ts2-track]');
    var k = 1;
    return function(){
      if (!mq.matches){
        g.style.removeProperty('--ts2-k'); g.style.removeProperty('--ts2-pin-top'); g.classList.remove('is-pinned'); k = 1;
        return;
      }
      var base = (main.offsetWidth || 1) / k;           // photo width at full size
      var min = Math.min(MIN, (window.innerHeight * 0.45) / base);
      var pinTop = headerBottom();
      g.style.setProperty('--ts2-pin-top', pinTop + 'px');
      var startY = scope.getBoundingClientRect().top + window.pageYOffset;
      var past = window.pageYOffset + pinTop - startY;
      var t = Math.max(0, Math.min(1, past / (base * (1 - min))));
      var nk = 1 - (1 - min) * t;
      // keep the photo the shopper swiped to in place while the carousel narrows
      var tw = track ? track.clientWidth : 0;
      var idx = (track && tw) ? Math.round(track.scrollLeft / tw) : 0;
      g.style.setProperty('--ts2-k', nk.toFixed(4));
      k = nk;
      if (track && tw && track.clientWidth !== tw && idx > 0) track.scrollLeft = idx * track.clientWidth;
      g.classList.toggle('is-pinned', past > 0 && Math.abs(g.getBoundingClientRect().top - pinTop) <= 1);
    };
  }
  var fns = [];
  for (var i = 0; i < blocks.length; i++) fns.push(one(blocks[i]));
  var ticking = false;
  function run(){ ticking = false; for (var j = 0; j < fns.length; j++) fns[j](); }
  function req(){ if (!ticking){ ticking = true; requestAnimationFrame(run); } }
  window.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', req);
  if (mq.addEventListener) mq.addEventListener('change', req);
  run();
})();
